"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDatatransLightBox = _interopRequireDefault(require("react-datatrans-light-box"));
var _Loader = _interopRequireDefault(require("../Loader/Loader"));
var _TextWithSyllabification = _interopRequireDefault(require("../SIA-WEBSITE/TextWithSyllabification/TextWithSyllabification"));
var _Form = _interopRequireDefault(require("../Form/Form"));
var _NumberInput = _interopRequireDefault(require("../NumberInput/NumberInput"));
var _TextInput = _interopRequireDefault(require("../TextInput/TextInput"));
var _FormFields = _interopRequireDefault(require("../Form/FormFields"));
var _validateQRNumber = require("./validateQRNumber");
var _isAphaNumeric = require("../../common/isAphaNumeric");
var _validateSIAID = require("./validateSIAID");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.credit-card-payment {\n  display: flex;\n  justify-content: center;\n  flex: 1; }\n  .credit-card-payment .container {\n    max-width: 492px;\n    width: 404px; }\n    .credit-card-payment .container #amount,\n    .credit-card-payment .container #invoice_number,\n    .credit-card-payment .container #sia_id,\n    .credit-card-payment .container #reference_number {\n      font-weight: 300 !important;\n      background-color: #f4f4f4 !important; }\n    .credit-card-payment .container .error {\n      color: #e41b13; }\n";
  const fileName = "CreditCardPayment_CreditCardPayment";
  const element = document.querySelector("style[data-sass-component='CreditCardPayment_CreditCardPayment']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const MIN_INVOICE_AMOUNT = 1;
const defaultFormData = {
  invoice_number: '',
  sia_id: '',
  reference_number: '',
  amount: ''
};
const errorMap = {
  amount: 'datatrans.credit-card-payment.amount.error',
  reference_number: 'datatrans.credit-card-payment.reference_number.error',
  sia_id: 'datatrans.credit-card-payment.sia_id.error',
  invoice_number: 'datatrans.credit-card-payment.invoice_number.error',
  transaction_id: 'datatrans.credit-card-payment.transaction-id.error'
};
const CreditCardPayment = _ref => {
  let {
    translate,
    lang,
    endpoint,
    transactionIdUrl,
    merchantId,
    production
  } = _ref;
  const [formData, setFormData] = (0, _react.useState)(defaultFormData);
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [formErrors, setFormErrors] = (0, _react.useState)(defaultFormData);
  const [lightbox, showLightbox] = (0, _react.useState)(false);
  const [lightboxError, setLightboxError] = (0, _react.useState)(false);
  const [transactionId, setTransactionId] = (0, _react.useState)('');
  const [paymentComplete, showPaymentComplete] = (0, _react.useState)('');
  const [pageUrl, setPageUrl] = (0, _react.useState)('');
  (0, _react.useEffect)(() => {
    const {
      url,
      slug
    } = processEndpoint(endpoint);
    if (slug !== 'pay') {
      setPageUrl(url);
      showPaymentComplete(slug);
    } else {
      setPageUrl(endpoint);
    }
  }, []);
  const processEndpoint = url => {
    const urlWithoutQueryString = url.split('?')[0];
    return {
      url: urlWithoutQueryString.split('/').slice(0, -1).join('/'),
      slug: urlWithoutQueryString.split('/')[urlWithoutQueryString.split('/').length - 1]
    };
  };
  async function fetchData() {
    try {
      const response = await fetch(`${transactionIdUrl}/datatrans/transaction`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          cent_amount: formData.amount * 100,
          lang,
          invoice_number: formData.invoice_number,
          ref_no: formData.reference_number,
          sia_id: formData.sia_id,
          success_url: `${pageUrl}/success`,
          cancel_url: `${pageUrl}/cancel`,
          error_url: `${pageUrl}/error`
        })
      });
      const data = await response.json();
      if (!data?.transactionId) {
        console.log('Transaction Id Error', data);
        setIsLoading(false);
        return setLightboxError(true);
      }
      setTransactionId(data.transactionId);
      triggerLightBox();
    } catch (error) {
      console.log('Fetch transaction Id error', error);
    }
  }
  const validateForm = () => {
    setFormErrors(defaultFormData);
    setLightboxError(false);
    let errors = {};
    Object.keys(formData).forEach(key => {
      if (formData[key] === '' || key === 'amount' && formData[key] < MIN_INVOICE_AMOUNT || key === 'reference_number' && !(0, _validateQRNumber.validateQRNumber)(formData[key]) || key === 'sia_id' && !(0, _validateSIAID.validateSIAID)(formData[key]) || key === 'invoice_number' && !(0, _isAphaNumeric.isAlphanumeric)(formData[key])) {
        const error = translate(errorMap[key]);
        errors[key] = error;
      }
    });
    setFormErrors(errors);
    return errors;
  };
  const onClickPrimaryButton = async () => {
    const errors = await validateForm();
    if (Object.values(errors).some(error => error !== '') || lightboxError) {
      return;
    }
    setIsLoading(true);
    showLightbox(false);
    await fetchData();
  };
  const triggerLightBox = () => {
    showLightbox(true);
    showPaymentComplete('');
  };
  const onChangeFormField = e => {
    let error = '';
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
    if (e.target.id === 'sia_id' && e.target.value.length > 6) {
      error = translate(errorMap.sia_id);
    }
    if (e.target.id === 'invoice_number' && !(0, _isAphaNumeric.isAlphanumeric)(e.target.value)) {
      error = translate(errorMap.invoice_number);
    }
    if (e.target.id === 'reference_number' && !(0, _validateQRNumber.validateQRNumber)(e.target.value)) {
      error = translate(errorMap.reference_number);
    }
    setFormErrors({
      ...formErrors,
      [e.target.id]: error
    });
  };
  const onAmountChange = value => {
    let error = '';
    setFormData({
      ...formData,
      amount: value
    });
    if (value?.length > 2 && value < MIN_INVOICE_AMOUNT) {
      error = translate(errorMap.amount);
    }
    setFormErrors({
      ...formErrors,
      amount: error
    });
  };
  const config = {
    merchantId,
    transactionId: transactionId,
    currency: 'CHF',
    production,
    language: lang
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "credit-card-payment sia-margin-05-top"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, paymentComplete === 'success' && /*#__PURE__*/_react.default.createElement("h3", {
    className: "sia-text-12 sia-margin-04-top sia-margin-04-bottom"
  }, translate('datatrans.credit-card-payment.complete')), paymentComplete !== 'success' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "title sia-text-12 sia-margin-02-bottom"
  }, translate('datatrans.credit-card-payment.title')), paymentComplete === 'error' && /*#__PURE__*/_react.default.createElement("h3", {
    className: "error sia-text-10 sia-margin-04-top sia-margin-04-bottom"
  }, translate('datatrans.credit-card-payment.failed')), paymentComplete === 'cancel' && /*#__PURE__*/_react.default.createElement("h3", {
    className: "error sia-text-10 sia-margin-04-top sia-margin-04-bottom"
  }, translate('datatrans.credit-card-payment.cancel')), !paymentComplete && /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-text-10 sia-margin-02-top sia-margin-02-bottom"
  }, /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, null, translate('datatrans.credit-card-payment.sub-title')))), !paymentComplete && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, lightbox ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isLoading ? /*#__PURE__*/_react.default.createElement(_Loader.default, null) : null, /*#__PURE__*/_react.default.createElement(_reactDatatransLightBox.default, _extends({
    onLoaded: () => {
      console.log('Lightbox Loaded');
      setIsLoading(false);
    },
    onCanceled: () => {
      console.log('Lightbox Canceled');
      setIsLoading(false);
    },
    onError: (data, error) => {
      console.log('Lightbox Error', data, error);
      setIsLoading(false);
    }
  }, config))) : null), paymentComplete !== 'success' && /*#__PURE__*/_react.default.createElement(_Form.default, {
    primaryButtonLabel: translate('datatrans.credit-card-payment.pay.button'),
    onClickPrimaryButton: () => {
      onClickPrimaryButton();
    }
  }, /*#__PURE__*/_react.default.createElement(_FormFields.default, null, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    id: "invoice_number" // D2025189312
    ,
    label: translate('datatrans.credit-card-payment.invoice_number.label'),
    onChange: onChangeFormField,
    value: formData.invoice_number || '',
    invalidText: formErrors.invoice_number,
    autoComplete: "off"
  }), /*#__PURE__*/_react.default.createElement(_NumberInput.default, {
    id: "sia_id",
    label: translate('datatrans.credit-card-payment.sia_id.label'),
    onChange: onChangeFormField,
    value: formData.sia_id || '',
    invalidText: formErrors.sia_id,
    autoComplete: "on"
  }), /*#__PURE__*/_react.default.createElement(_NumberInput.default, {
    id: "reference_number" // 011845020020251893126802748
    ,
    label: translate('datatrans.credit-card-payment.reference_number.label'),
    onChange: onChangeFormField,
    value: formData.reference_number || '',
    invalidText: formErrors.reference_number,
    autoComplete: "off"
  }), /*#__PURE__*/_react.default.createElement(_NumberInput.default, {
    id: "amount",
    label: translate('datatrans.credit-card-payment.amount.label'),
    onChange: (event, value) => onAmountChange(value),
    value: formData.amount || '',
    invalidText: formErrors.amount,
    formatting: "CHF",
    autoComplete: "off"
  })), lightboxError && /*#__PURE__*/_react.default.createElement("h3", {
    className: "error sia-text-10 sia-margin-04-top sia-margin-04-bottom"
  }, translate('datatrans.credit-card-payment.transaction-id.error')))));
};
var _default = exports.default = CreditCardPayment;